
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Clavicle_fracture_classification",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Orthopaedics/Clavicle_fracture_classification.vue